/* eslint no-undef: 0 */
import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

var routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "대구로",
      metaTags: [
        {
          name: "description",
          content:
            "대구시민, 소상공인, 대구시와 함께하는 대구형 배달앱, 주문은 대구로!, 배달은 댁으로!",
        },
      ],
    },
  },
  {
    path: "/enter/info",
    name: "Enter_Info",
    component: () =>
      import(/* webpackChunkName: "enter_info" */ "../views/enter/Info.vue"),
  },
  {
    path: "/enter/insert",
    name: "Enter_Insert",
    component: () =>
      import(
        /* webpackChunkName: "enter_insert" */ "../views/enter/InsertInfo.vue"
      ),
  },
  {
    path: "/enter/complete",
    name: "Enter_Complete",
    component: () =>
      import(
        /* webpackChunkName: "enter_complete" */ "../views/enter/Complete.vue"
      ),
  },
  {
    path: "/check/user_check",
    name: "User_Check",
    component: () =>
      import(/* webpackChunkName: "user_check" */ "../views/check/Info_1.vue"),
  },
  {
    path: "/check/user_info",
    name: "User_Info",
    component: () =>
      import(
        /* webpackChunkName: "user_info" */ "../views/check/Info_2_page.vue"
      ),
  },
  {
    path: "/404",
    name: "Error",
    component: () => import(/* webpackChunkName: "404" */ "../views/Error.vue"),
  },
  {
    path: "/App_down",
    name: "AppDown",
    component: () =>
      import(/* webpackChunkName: "app_down" */ "../views/AppDown.vue"),
    meta: {
      metaTags: [
        {
          name: "robots",
          content: "noindex",
        },
      ],
    },
  },
  {
    path: "/Policy/privacy",
    name: "Privacy",
    component: () =>
      import(/* webpackChunkName: "privacy" */ "../views/Policy/Privacy.vue"),
  },
  {
    path: "/Policy/Service",
    name: "Service",
    component: () =>
      import(/* webpackChunkName: "Service" */ "../views/Policy/Service.vue"),
  },
  {
  path: "*",
  redirect: () => {
    const rawPath = window.location.pathname;
    if (rawPath.endsWith(")")) {
      return "/";
    }
    return "/404";
  },
},
];

var router = new VueRouter({
  mode: "history", //"hash",//
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  console.log("path:" + to.fullPath);


  if (to.fullPath === "/app_down") {
    const path = "/#" + to.fullPath;
    next(path);
    return;
  }

  // if (to.fullPath.substr(0,2) === "/#") {
  //     const path = to.fullPath.substr(2);
  //     next(path);
  //     return;
  // }

  next();
});

export default router;